import constructMetaObject from './constructMetaObject'
import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformPostMeta (data) {
	return applyToOneOrMany(_transformPostMeta, data)
}

function _transformPostMeta (post) {
	post.meta = constructMetaObject(post)
	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformPostMeta.js